// extracted by mini-css-extract-plugin
export default {"card":"Home_card__XRJBU","text":"Home_text__bwQM6","image":"Home_image__9b45O","bg":"Home_bg__kw-07"};